import { useEffect, useRef } from 'react';

/**
 * Cierra un modal/panel con la tecla Escape mientras `active` sea true.
 * Auditoría de popups QA 2026-09-13: los modales de confirmación del admin
 * solo se cerraban con clic afuera o con los botones.
 *
 * Uso: useEscapeKey(showDeleteConfirm, () => setShowDeleteConfirm(false));
 */
export default function useEscapeKey(active, onEscape) {
  const handlerRef = useRef(onEscape);
  handlerRef.current = onEscape;

  useEffect(() => {
    if (!active) return undefined;
    const onKeyDown = (event) => {
      if (event.key !== 'Escape') return;
      if (typeof handlerRef.current === 'function') handlerRef.current(event);
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [active]);
}
